"use client";

import type { ToasterProps } from "sonner";
import { Toaster as Sonner } from "sonner";

import { useThemeContext } from "@/app/providers/ThemeProvider";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useThemeContext();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="top-center"
      offset="80px"
      gap={12}
      visibleToasts={3}
      closeButton
      duration={5000}
      toastOptions={{
        unstyled: false,
        style: {
          background: "var(--toast-bg)",
          color: "var(--toast-fg)",
          border: "1.5px solid var(--toast-border)",
          boxShadow: "var(--toast-shadow)",
        },
        classNames: {
          toast: "rounded-lg",
          description: "text-muted-foreground opacity-90",
          actionButton: "bg-primary text-primary-foreground font-medium",
          cancelButton: "bg-muted text-muted-foreground",
          closeButton:
            "!left-auto !right-1 !top-3 !bg-transparent !border-0 text-muted-foreground opacity-70 hover:opacity-100 transition-opacity [&_svg]:!w-3.5 [&_svg]:!h-3.5",
          success:
            "!bg-[var(--toast-success-bg)] !border-[var(--toast-success-border)] [&_[data-icon]]:!text-[var(--toast-success-icon)]",
          error:
            "!bg-[var(--toast-error-bg)] !border-[var(--toast-error-border)] [&_[data-icon]]:!text-[var(--toast-error-icon)]",
          info: "!border-[var(--toast-info-border)] [&_[data-icon]]:!text-[var(--toast-info-icon)]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
